module.exports = __webpack_public_path__ + "img/logo-transparent.66feca11.png";